<template>
  <div v-if="question">
    <div  class="panel-body" v-for="(solution, key) in solutions" :key="key">
      <div class="">
        <div class="forum-heading">
          <div class="pull-right" style="height: 57px;margin-left: 10px">
            <div style="margin-top: 10px" class="desc">{{solution.created_at | moment("LLL")}}</div>
          </div>
          <h4>{{solution.title}}</h4>
          <div style="margin-top: 10px" class="desc text-justify" v-html="solution.content"></div>
          <div class="row" style="margin-top: 10px">
            <div v-for="(file, key) in solution.files" :key="key" class="col-xs-6">
              <a :href="api_url + file.filename" target="_blank">{{file.filename.match('.*\/(.*)')[1]}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body" v-if="$auth.user().id !== question.consultant_id">
      <div class="row">
        <div class="col-xs-12 forum-heading text-center">
          <button class="btn  btn-info" @click="modalSolution(null)">New Response</button>
        </div>
      </div>
    </div>

    <div class="modal fade hmodal-info" id="modalSolution" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <form @submit="submitSolution">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
              <h4 class="modal-title">Response</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="title" class="required">Title</label>
                    <input id="title" v-model="currentSolution.title" class="form-control" required/>
                  </div>
                  <div class="form-group">
                    <label for="content" class="required">Content</label>
                    <textarea id="content" v-model="currentSolution.content" class="form-control" rows="7" required></textarea>
                  </div>
                  <div class="form-group " v-bind:class="{'has-error' : errorFiles, 'has-info' : errorFiles === false}">
                    <label for="files" class="">Additional Files</label>
                    <upload-file id="files" :files="currentSolution.files" :type="'proposal'" :uploadFiles="uploadFiles"/>
                    <span v-if="errorFiles" class="help-block text-danger">{{ errorFiles }}</span>
                  </div>

                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Confirm</vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>
<script>
import VueLadda from 'vue-ladda'
import UploadFile from '../../components/question/UploadFile'

export default {
  components: {VueLadda, UploadFile},
  props: ['question'],
  name: 'SolutionExpert',
  data () {
    return {
      submit: {
        loading: false,
        'dataStyle': ''
      },
      solutions: [],
      solution: null,
      uploadFiles: [],
      errorFiles: null,
      currentSolution: {
        id: null,
        title: null,
        content: null,
        files: []
      },
      api_url: process.env.API_URL
    }
  },
  methods: {
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadFiles.length !== 0) {
          let data = new FormData()

          this.uploadFiles.forEach((file) => {
            data.append('files[]', file)
          })
          data.append('target', 'solution_file')
          data.append('additional_path', this.question.id)

          this.axios.post('/files/', data).then((response) => {
            this.uploadFiles.forEach((file) => {
              if (typeof response.data.files[file.name] !== 'undefined') {
                this.currentSolution.files.push({filename: response.data.path + response.data.files[file.name]})

                this.axios.post('solution/' + this.currentSolution.id + '/file', {
                  filename: response.data.path + response.data.files[file.name]
                }).then((response) => {
                })
              }
            })
            this.uploadFiles = []
            resolve(response)
          }).catch((error) => {
            if (typeof error.response !== 'undefined') {
              if (error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, max upload size is 10 Mo',
                  placement: 'bottom-right'
                })
              } else {
                let errors = error.response.data.errors
                switch (error.response.data.code) {
                  case 1:
                    this.errorFiles = errors['files'][0]
                    break
                }
              }
            }
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    submitSolution: function (e) {
      e.preventDefault()
      this.submit.loading = true

      if (this.currentSolution.id === null) {
        this.axios.post('/solution/', {
          question_id: this.question.id,
          title: this.currentSolution.title,
          content: this.currentSolution.content
        })
          .then((response) => {
            this.currentSolution.id = response.data.id
            this.upload().then((response) => {
              $('#modalSolution').modal('hide')
              this.getResources()
            })
          }).catch((error) => {
          }).finally(() => {
            this.submit.loading = false
          })
      } else {
        this.axios.patch('/solution/' + this.currentSolution.id, {
          question_id: this.question.id,
          title: this.currentSolution.title,
          content: this.currentSolution.content
        }).then(() => {
          this.upload().then((response) => {
            $('#modalSolution').modal('hide')
            this.getResources()
          })
        }).finally(() => {
          this.submit.loading = false
        })
      }
    },
    modalSolution: function (solution) {
      this.errorFiles = null
      this.uploadFiles = []

      if (solution === null) {
        this.currentSolution = {
          id: null,
          title: null,
          content: null,
          files: []
        }
      } else {
        this.currentSolution = solution
      }

      $('#modalSolution').modal('show')
    },
    getResources: function () {
      if (this.question !== null && typeof this.question !== 'undefined') {
        this.axios.get('/question/receive/' + this.question.id + '?relations={solutions}')
          .then((response) => {
            this.solutions = response.data.solutions
          }).catch(function (error) {
          })
      }
    }
  },
  beforeMount () {
    if (this.question !== null && typeof this.question.solutions !== 'undefined') {
      this.solutions = this.question.solutions
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatSolution/SolutionExpert.vue